class CookieHelper {
    getCookieValue(key) {
        return cf.utils.getCookieValue(key);
    }

    setCookieValue(key, value, expireDate, path) {
        cf.utils.setCookieValue(key, value, expireDate, path);
    }

    deleteCookie(key, path) {
        cf.utils.deleteCookie(key, path);
    }
}

export default new CookieHelper();
